<template>
  <div class="page-container">
    <div class="page-card">
      <!-- 表单头部 -->
      <div class="page-card__header">
        添加参展展品
      </div>

      <!-- 表单内容 -->
      <div class="page-card__body">
        <el-form :model="productForm" label-width="120px" :rules="rules" ref="productForm">
          <el-row :gutter="20" style="text-align: left;font-size: 14px;line-height: 30px">
            <el-col :span="6">
              <el-image v-if="productForm.img !== ''"
                        :src="imgUrl+productForm.img" style="width: 200px;height: 200px"></el-image>
              <el-form-item prop="img" label-width="0px">
                <el-upload
                  class="avatar-uploader"
                  :action="imagesrc"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :headers="headers"
                  :before-upload="beforeAvatarUpload">
                  <el-button size="small" type="primary" round>点击上传产品图</el-button>
                  <div slot="tip" class="el-upload__tip">最佳展示尺寸：1:1，建议500 x 500像素以上</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="18">

              <el-form-item prop="title" label="产品名称：">
                <el-input placeholder="请填写产品名称" v-model="productForm.title"></el-input>
              </el-form-item>


              <el-form-item prop="type" label="产品分类：">
                <el-radio-group v-model="productForm.type">
                  <el-radio label="紧固件"></el-radio>
                  <el-radio label="设备"></el-radio>
                  <el-radio label="模具"></el-radio>
                  <el-radio label="表面处理"></el-radio>
                  <el-radio label="原材料"></el-radio>
                  <el-radio label="检测"></el-radio>
                  <el-radio label="其他"></el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item prop="info" label="产品介绍：">
                <el-input type="textarea" :rows="6" placeholder="请填写产品介绍" v-model="productForm.info"></el-input>
              </el-form-item>

              <el-row style="margin: 20px;text-align: center">
                <el-button type="primary" round @click="productListData('productForm')">确定发布</el-button>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../../utils/api'

  export default {
    name: "productAdd",
    data() {
      return {
        productForm: {
          title: '',
          info: '',
          type: '',
          img: "",
        },

        rules: {
          img: [
            {required: true, message: '请输入产品图', trigger: 'blur'},
          ],

          title: [
            {required: true, message: '请输入产品名称', trigger: 'blur'},
          ],
          type: [
            {required: true, message: '请输入产品分类', trigger: 'blur'},
          ],
          info: [
            {required: true, message: '请输入产品介绍', trigger: 'blur'},
          ],
        },

        headers: {"Authorization": "JWT " + localStorage.getItem('token')},
        imagesrc: this.baseUrl + "/user/uploadfile/product/",
        imgUrl: 'https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/product/',
      }
    },
    mounted() {

    },
    methods: {

      // 提交新增产品表单
      productListData(formname) {
        this.$refs[formname].validate((valid) => {
          if (valid) {
            let user = localStorage.getItem('userid');
            let url = this.baseUrl + '/user/products/';
            api.postData(url, {
              title: this.productForm.title,
              info: this.productForm.info,
              type: this.productForm.type,
              img: this.productForm.img,
              user: user
            }).then((res) => {
              this.$message({
                message: '添加产品成功',
                type: 'success'
              })
              this.$router.push({name: 'productList'})
            })
          }
        })
      },

      // 图片上传成功回调
      handleAvatarSuccess(res, file) {
        let imageUrl = URL.createObjectURL(file.raw);
        this.productForm.img = res.filename;
      },

      // 图片上传前校验
      beforeAvatarUpload(file) {
      },
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/manage/productAdd.vue